module.exports = __webpack_public_path__ + "media/images/noticias/placeholderdos-d5d9dffe9342c9d967d9ea39a35f962d.jpg";